import {ChangeDetectorRef, Component, EventEmitter, OnInit, ViewChild} from '@angular/core';
import {StateService} from '@uirouter/angular';
import {Transition} from '@uirouter/angular';
import {DataService} from "../../services/data.service";
import {UserProfileService} from "../../services/user-profile.service";
import {LogService} from "../../services/log.service";
import {FrontEndService} from "../../services/front-end.service";
import {ImageUploadComponent} from "angular2-image-upload";
import {UserManagementService} from "../../services/user-management.service";

@Component({
    selector: 'app-create-user-profile-details',
    templateUrl: './create-user-profile-details.component.html',
    styleUrls: ['./create-user-profile-details.component.scss']
})
export class CreateUserProfileDetailsComponent implements OnInit {

    fullScreenLoader = false;
    profileId = 0;
    userProfile = {};
    state = "create_profile";
    errorMessage = "";
    images = [];
    uploadImage: any = null;
    technology_expertise = [];
    ip_expertise = [];
    users = [
        {
            id: 'null',
            text: "Select User"
        }
    ];

    years = [
        {
            id: 'null',
            text: "Years"
        }
    ];
    months = [
        {
            id: 'null',
            text: "Months"
        }
    ];

    userOptions = {
        placeholder: 'Select User'
    };
    yearOptions = {
        placeholder: 'Year'
    };
    monthOptions = {
        placeholder: 'Month'
    };

    name_error = false;
    username_error = false;
    designation_error = false;
    introduction_error = false;
    academic_error = false;
    total_experience_error = false;
    ip_experience_error = false;
    ip_expertise_error = false;
    technology_expertise_error = false;

    // On error, Focus variables
    public name_focus = new EventEmitter<boolean>();
    public username_focus = new EventEmitter<boolean>();
    public designation_focus = new EventEmitter<boolean>();
    public introduction_focus = new EventEmitter<boolean>();
    public academic_focus = new EventEmitter<boolean>();
    public total_experience_years_focus = new EventEmitter<boolean>();
    public total_experience_months_focus = new EventEmitter<boolean>();
    public ip_experience_years_focus = new EventEmitter<boolean>();
    public ip_experience_months_focus = new EventEmitter<boolean>();
    public ip_expertise_focus = new EventEmitter<boolean>();
    public technology_expertise_focus = new EventEmitter<boolean>();

    @ViewChild('imageUpload') imageUpload: ImageUploadComponent;

    static arrayFromJson(arrayJson) {
        const newArray = [];
        for (let i = 0; i < arrayJson.length; i++) {
            newArray[i] = arrayJson[i].value
        }
        return newArray;
    }

    constructor(
        public dataService: DataService,
        public front_end_service: FrontEndService,
        private userManagementService: UserManagementService,
        private userProfileService: UserProfileService,
        public stateService: StateService,
        private transition: Transition,
        private logService: LogService,
        private cdr: ChangeDetectorRef
    ) { }

    ngOnInit() {

        this.loadMonthsAndYears();

        if (this.transition.params().user_id != null) {
            this.state = "edit_profile";
            this.profileId = +this.transition.params().user_id;

            if (parseInt(this.dataService.currentUser['role'], 10) > 1 && this.profileId !== this.dataService.currentUser['id']) {
                this.stateService.go("Forbidden");
            }
        } else if (parseInt(this.dataService.currentUser['role'], 10) > 1) {
            this.stateService.go("Forbidden");
        }

        this.getAllExpertise();
    }

    loadMonthsAndYears() {
        for (let i = 0; i <= 11; i++) {
            this.months.push(
                {
                    id: i.toString(),
                    text: i.toString()
                },
            )
        }

        for (let i = 0; i <= 20; i++) {
            this.years.push(
                {
                    id: i.toString(),
                    text: i.toString()
                },
            )
        }
    }

    getAllExpertise() {
        this.fullScreenLoader = true;
        this.userProfileService.getIpChoices((response) => {
            this.ip_expertise = response;
            this.userProfileService.getTechChoices((response2) => {
                this.technology_expertise = response2;
                if (this.profileId !== 0) {
                    this.getProfileDetails();
                } else {
                    this.getAllUsers();
                }
            })
        })
    }

    getAllUsers() {
        this.userManagementService.userList((userResponse) => {
            if (userResponse.status) {
                this.users = [];
                userResponse.data.forEach((user) => {
                    if (!user.has_profile) {
                        this.users.push(
                            {
                                "id": user.id,
                                "text": user.username
                            }
                        )
                    }
                });

            }
            this.fullScreenLoader = false;
        });
    }

    getProfileDetails() {
        this.fullScreenLoader = true;
        this.userProfileService.getProfileDetails(this.profileId, (response) => {
            if (response.status) {
                this.users = [
                    {
                        "id": response.data['username'],
                        "text":response.data['username']
                    }
                ];

                this.userProfile = response.data;

                const ipExpertises = [];
                if (this.userProfile.hasOwnProperty("ip_expertise")) {
                    (this.userProfile['ip_expertise'] as Array<string>).forEach((ipExpertise) => {
                        ipExpertises.push({value: ipExpertise, display: ipExpertise});
                    });
                }
                this.userProfile['ip_expertise'] = ipExpertises;

                const techExpertises = [];
                if (this.userProfile.hasOwnProperty("technology_expertise")) {
                    (this.userProfile['technology_expertise'] as Array<string>).forEach((techExpertise) => {
                        techExpertises.push({value: techExpertise, display: techExpertise});
                    });
                }
                this.userProfile['technology_expertise'] = techExpertises;

                this.cdr.detectChanges();

                if (this.userProfile['image'] && this.userProfile['image'].trim() !== "") {
                    this.imageUpload.deleteAll();
                    this.images = [this.userProfile['image']];
                }
            } else if(this.profileId === parseInt(this.dataService.currentUser['id'], 10)) {
                this.state = "create_profile";
                this.profileId = 0;
                this.getAllUsers();
            }
            this.fullScreenLoader = false;
        });
    }

    deleteProfile(profileId) {
        this.front_end_service.confirmAlert('confirm', 'delete_profile_confirmation', 'warning', (result) => {
            if (result.value) {
                this.fullScreenLoader = true;
                this.userProfileService.deleteProfile(profileId, (response) => {
                    if (response.status) {
                        this.front_end_service.addToast(
                            "Success",
                            "profile_deleted_successfully",
                            "success"
                        );
                        this.front_end_service.back();
                    }
                    this.fullScreenLoader = false
                });
            }
        });
    }

    saveProfile(userProfile) {
        this.hideAllErrors();
        if (this.profileId === 0 && (userProfile['user_id'] === undefined || userProfile['user_id'].trim() === "")) {
            this.username_focus.emit(true);
            this.username_error = true;
            this.errorMessage = 'enter_a_username';
        } else if (userProfile['designation'] === undefined || userProfile['designation'].trim() === "") {
            this.designation_focus.emit(true);
            this.designation_error = true;
            this.errorMessage = 'enter_a_designation';
        } else if (userProfile['introduction'] === undefined || userProfile['introduction'].trim() === "") {
            this.introduction_focus.emit(true);
            this.introduction_error = true;
            this.errorMessage = 'enter_a_introduction';
        } else if (userProfile['academic'] === undefined || userProfile['academic'].trim() === "") {
            this.academic_focus.emit(true);
            this.academic_error = true;
            this.errorMessage = 'enter_a_academic';
        } else if (userProfile['total_experience_years'] === undefined || userProfile['total_experience_years'] === 'null') {
            this.total_experience_years_focus.emit(true);
            this.total_experience_error = true;
            this.errorMessage = 'enter_total_experience';
        } else if (userProfile['total_experience_months'] === undefined || userProfile['total_experience_months'] === 'null') {
            this.total_experience_months_focus.emit(true);
            this.total_experience_error = true;
            this.errorMessage = 'enter_total_experience';
        } else if (userProfile['ip_experience_years'] === undefined || userProfile['ip_experience_years'] === 'null') {
            this.ip_experience_years_focus.emit(true);
            this.ip_experience_error = true;
            this.errorMessage = 'enter_ip_experience';
        } else if (userProfile['ip_experience_months'] === undefined || userProfile['ip_experience_months'] === 'null') {
            this.ip_experience_months_focus.emit(true);
            this.ip_experience_error = true;
            this.errorMessage = 'enter_ip_experience';
        }  else if (userProfile['ip_expertise'] === undefined || userProfile['ip_expertise'].length === 0) {
            this.ip_expertise_focus.emit(true);
            this.ip_expertise_error = true;
            this.errorMessage = 'enter_ip_expertise';
        } else if (userProfile['technology_expertise'] === undefined || userProfile['technology_expertise'].length === 0) {
            this.technology_expertise_focus.emit(true);
            this.technology_expertise_error = true;
            this.errorMessage = 'enter_technology_expertise';
        } else {
            const formData = JSON.parse(JSON.stringify(userProfile));
            formData['ip_expertise'] = JSON.stringify(CreateUserProfileDetailsComponent.arrayFromJson(formData['ip_expertise']));
            formData['technology_expertise'] = JSON.stringify(CreateUserProfileDetailsComponent.arrayFromJson(formData['technology_expertise']));

            if (this.uploadImage) {
                this.logService.printLog("Images - ", this.images);
                formData['image'] = this.uploadImage;
            }

            this.fullScreenLoader = true;
            if (this.profileId === 0) {
                this.userProfileService.createProfile(formData, (response) => {
                    if (response.status) {
                        this.front_end_service.addToast("success", "profile_created_successfully", "success");
                        this.stateService.go("editProfile", { "user_id": response.data["id"] })
                    }
                    this.fullScreenLoader = false;
                });
            } else {
                formData['id'] = this.profileId;
                delete formData.name;
                delete formData.username;
                this.userProfileService.editProfile(this.profileId, formData, (response) => {
                    if (response.status) {
                        this.front_end_service.addToast("success", "profile_updated_successfully", "success");
                    }
                    this.fullScreenLoader = false;
                });
            }
        }
    }

    onUploadFinished(event) {
        this.images = [];
        // this.imageUpload.deleteAll();
        this.uploadImage = event.file;
    }

    onRemoved(event) {
        this.images = [];
        // this.imageUpload.deleteAll();
        this.uploadImage = null;
    }

    hideAllErrors() {
        this.name_error = false;
        this.username_error = false;
        this.designation_error = false;
        this.introduction_error = false;
        this.academic_error = false;
        this.total_experience_error = false;
        this.ip_experience_error = false;
        this.ip_expertise_error = false;
        this.technology_expertise_error = false;
    }

    experienceChanged(isTotal: boolean, isYears: boolean, event) {
        if (isTotal && isYears) {
            this.userProfile['total_experience_years'] = event.value;
        } else if (isTotal && !isYears) {
            this.userProfile['total_experience_months'] = event.value;
        } else if (!isTotal && isYears) {
            this.userProfile['ip_experience_years'] = event.value;
        } else if (!isTotal && !isYears) {
            this.userProfile['ip_experience_months'] = event.value;
        }
        this.cdr.detectChanges();
    }

    userChanged(event) {
        this.userProfile['user_id'] = event.value;
        this.cdr.detectChanges();
    }
}
